import { useQuery } from '@tanstack/react-query';

import { useCurrentUserQuery } from '@/shared/legacy/hooks/useCurrentUserQuery';
import { QueryKey } from '@/types/query';
import { sendIndeedConfig } from 'shared/legacy/hooks/useBrowserExtension/indeed/sendIndeedConfig';
import { getFeatureToggleActions } from '../lib';
import { toFeatureToggleViewModel } from '../model';
import { featureToggleClient } from './client';

export const useGetFeatureTogglesQuery = () => {
  const { data: currentUser } = useCurrentUserQuery();
  const currentUserId = currentUser?.id;

  return useQuery({
    queryKey: [QueryKey.useGetFeatureToggles, currentUserId],
    queryFn: async () => {
      const { data } = await featureToggleClient.getFeatureToggles();
      const featureToggles = data.map(toFeatureToggleViewModel);

      getFeatureToggleActions().setFeatureToggles(featureToggles);

      sendIndeedConfig();

      return featureToggles;
    },
    retry: false,
    initialData: [],
    initialDataUpdatedAt: 0,
    enabled: currentUserId !== undefined,
  });
};
